<template>
  <div>
    <b-card  style="margin:20px" class="ma-3">
   
        <b-row>
          <b-col cols="2" style="width:300px">
            <Sidebar></Sidebar>
          </b-col>
             <div class="mr-1" style="border:solid;width:1px"></div>
          <b-col>
           
            <div>
              <div>
               
               
                <b-form-group 
                  id="fieldset-horizontal"
                  label-cols-sm="4"
                  label-cols-lg="3"
                  label="Curent User Role Name"
                >
                  <b-form-input disabled v-model="text"></b-form-input>
                </b-form-group>
                <div>
                  <b-form-group
                    id="fieldset-horizontal"
                    label-cols-sm="4"
                    label-cols-lg="3"
                    label="New User Role Name
"
                  >
                   <b-form-input  placeholder="Enter your name"></b-form-input>
   
                  </b-form-group>
                </div>
               

             
                <div>
                  <b-button variant="primary">Update</b-button>
                </div>
              </div>
            </div>
          </b-col>
        </b-row>
      
    </b-card>
  </div>
</template>

<script>
import Sidebar from "../AdminSlidebar";
export default {
  name: "AdminEdit",

  components: {
    Sidebar
  },
  data() {
    return {
      text: "xxxxxxxxxxxxxxxxxxx"
    };
  }
};
</script>

<style>
</style>